import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';

@Component({
  selector: 'app-agent-monthly-commission',
  templateUrl: './agent-monthly-commission.component.html',
  styleUrls: ['./agent-monthly-commission.component.scss']
})
export class AgentMonthlyCommissionComponent implements OnInit {
  is_document_available_dict = {
    'commission_report_c1': true,
    'commission_report_c2': true,
    'commission_report_c3': true,
    'commission_report_c4': true,
    'commission_report_c5': true,
    'commission_report_c1b': true,
    'commission_report_c2b': true,
    'commission_report_slip_charge': true,
  };
  is_document_available = true;
  is_document_available_for_milk_sale_report: boolean = true;
  document_file: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  month_list_for_last_12_months: any = [];
  selected_month_for_run: any = null;
  selected_month_for_report: any = null;
  global_config: any;
  mobile_number: any = null;
  document_data: any = {};
  document_file_for_milk_sale: any = null;
  is_commission_run = false;
  from_date_for_run: any = null;
  to_date_for_run: any = null;
  from_date_for_report: any = null;
  to_date_for_report: any = null;
  from_date_for_milk_sale_report: any = null;
  to_date_for_milk_sale_report: any = null;
  progress = 0;
  progress_name = 0;
  run_split: any = [];
  selected_run_split: any = {};
  sub_column_with_file_list = [{ 'label': null, 'file': null }];
  is_sub_column_available = false;

  constructor(private httpService: HttpService) {
    let today = new Date();
    today.setDate(1);
    let data_dict = {
      'month_in_string': this.monthNames[today.getMonth()],
      'month_in_integer': today.getMonth(),
      'year': today.getFullYear()
    }
    this.month_list_for_last_12_months.push(data_dict);
    for (let i = 0; i <= 11; i++) {
      today.setMonth(today.getMonth() - 1);
      let data_dict = {
        'month_in_string': this.monthNames[today.getMonth()],
        'month_in_integer': today.getMonth(),
        'year': today.getFullYear()
      };
      this.month_list_for_last_12_months.push(data_dict);
    }
    console.log(this.month_list_for_last_12_months);
    this.httpService.getGlobalConfigData().subscribe((data) => {
      console.log(data);
      this.global_config = data;
      this.mobile_number = data['mobile_number'];
    }, (error) => {
      console.error(error);
    });
  }

  convertExcelToBase64(event, index) {
    console.log(event);
    console.log('to base 64');
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onloadend = (e) => {
      console.log(reader.result);
      this.sub_column_with_file_list[index]['file'] = reader.result;
    };
    console.log(reader.readAsDataURL(file));
    console.log(this.sub_column_with_file_list)
  }

  backgroundColorForRunSpliList(split_id) {
    if (this.selected_run_split.hasOwnProperty('id')) {
      if (split_id === this.selected_run_split['id']) {
        return '#f3a353';
      } else {
        return '#66615c';
      }
    } else {
      return '#66615c';
    }
  }

  addNewColumnCalled() {
    let temp_dict = { 'label': null, 'file': null };
    this.sub_column_with_file_list.push(temp_dict);
  }

  removeLastColumnCalled(index) {
    this.sub_column_with_file_list.splice(index, 1);
  }

  checkRunDiablebutton() {
    if (this.from_date_for_run == null || this.to_date_for_run == null) {
      return true;
    } else {
      if (this.is_sub_column_available) {
        if (this.sub_column_with_file_list.length === 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  }

  progressBarCalled() {
    setInterval(() => {
      if (this.is_commission_run) {
        return false;
      }
      this.progress += 1;
      this.progress_name += 1;
    }, 3000);
  }

  runSpitClickCalled(split) {
    console.info(split)
    this.selected_run_split = split;
  }

  runBoothCommissionCalled() {
    this.is_commission_run = true;
    let data_dict = {
      'from_date': this.from_date_for_run,
      'to_date': this.to_date_for_run,
      'sub_column_list': this.sub_column_with_file_list,
      'is_sub_column_available': this.is_sub_column_available
    };
    // this.progressBarCalled();
    this.progress = 0;
    this.progress_name = 0;
    this.httpService.runBoothCommission(data_dict).subscribe((data) => {
      console.log(data);
      this.progress = 100;
      this.progress_name = 70;
    }, (error) => {
      console.error(error);
    });
  }

  subColumnChanged(event) {
    if (!event.checked) {
      this.sub_column_with_file_list = [{ 'label': null, 'file': null }];
    }
  }

  getClicked() {
    this.selected_run_split = {};
    this.httpService.serveRunListForCommission(this.selected_month_for_report).subscribe((data) => {
      console.info(data);
      this.document_data = [];
      if (data['is_data_available']) {
        this.run_split = data['data'];
      } else {
        this.run_split = [];
        this.selected_run_split = {};
        alert('Data Not Available For Selected Month');
        return false;
      }
    }, (error) => {
      console.error(error);
    });
  }

  generateReportCalled(report_option) {
    this.is_document_available_dict[report_option] = false;
    this.selected_run_split['report_option'] = report_option;
    this.httpService.getAgentMonthlyCommissionRerpot(this.selected_run_split).subscribe((data) => {
      console.log(data);
      this.document_data[report_option] = data[report_option];
      this.is_document_available_dict[report_option] = true;
    }, (error) => {
      this.is_document_available_dict[report_option] = true;
    });
  }

  downloadClicked(report_option, file_format) {
    let linkSource = null;
    let file_name = null;
    if (file_format === 'pdf') {
      linkSource = 'data:application/pdf;base64,' + this.document_data[report_option][file_format];
      file_name = this.document_data[report_option]['pdf_file_name'];

    } else {
      linkSource = 'data:application/octet-stream;base64,' + this.document_data[report_option][file_format];
      file_name = this.document_data[report_option]['excel_file_name'];
    }
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = file_name;
    downloadLink.click();
  }


  getClickedForMilkSaleReport() {
    let data_dict = {
      'from_date': this.from_date_for_milk_sale_report,
      'to_date': this.to_date_for_milk_sale_report
    }
    this.document_file_for_milk_sale = null;
    this.is_document_available_for_milk_sale_report = false;
    this.httpService.generateTotalMilkSaleReport(data_dict).subscribe((data) => {
      console.log(data);
      this.document_file_for_milk_sale = data;
      this.is_document_available_for_milk_sale_report = true;
    }, (error) => {
      this.is_document_available_for_milk_sale_report = true;
    });
  }

  downloadClickedForMilkSale() {
    const linkSource = 'data:application/pdf;base64,' + this.document_file_for_milk_sale['pdf'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file_for_milk_sale['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }



  ngOnInit() {
  }

}
